/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Product_Description_LabelInputs */

const en_admin_payments_product_description_label = /** @type {(inputs: Admin_Payments_Product_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const zh_admin_payments_product_description_label = /** @type {(inputs: Admin_Payments_Product_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Admin_Payments_Product_Description_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_product_description_label = /** @type {((inputs?: Admin_Payments_Product_Description_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Product_Description_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_product_description_label(inputs)
	return zh_admin_payments_product_description_label(inputs)
});
export { admin_payments_product_description_label as "admin.payments.product_description_label" }